const testimonials = [
  {
    quote: 'ECOS came in with a competitive price and got the job done when they said they would! We had quite a bit of asbestos needing abatement for a construction project and they handled everything professionally from start to finish.',
    name: 'Ann J.',
    title: 'Verified Customer',
    company: 'Asbestos Abatement Project',
    stars: 5,
    featured: true,
  },
  {
    quote: 'Thank you ECOS for your prompt and thorough service. Would recommend to anyone needing help with mold or any other environmental situation.',
    name: 'Cameron W.',
    title: 'Verified Customer',
    company: 'Mold Remediation',
    stars: 5,
    featured: false,
  },
  {
    quote: 'Avery and his team at ECOS handled the whole thing so fast, and so well. They made the whole thing super easy! I am so glad I called them.',
    name: 'Chase C.',
    title: 'Verified Customer',
    company: 'Disaster Restoration',
    stars: 5,
    featured: false,
  },
  {
    quote: 'Great people, great service, and responsive. I recommend calling them if you need any restoration services. They were professional from first contact to final clearance.',
    name: 'Mike R.',
    title: 'Verified Customer',
    company: 'Restoration Services',
    stars: 5,
    featured: false,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-ecos-slate-mid py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div>
            <p className="text-ecos-green text-xs uppercase tracking-widest font-semibold mb-4">Client Reviews</p>
            <h2 className="font-serif text-ecos-charcoal text-4xl lg:text-5xl font-semibold leading-tight max-w-xl">
              Trusted by Colorado&apos;s Commercial &amp; Industrial Leaders
            </h2>
          </div>
          <div className="flex items-center gap-6 flex-shrink-0">
            <div className="text-center">
              <p className="font-serif text-ecos-charcoal text-4xl font-semibold">4.9</p>
              <div className="flex items-center justify-center gap-0.5 my-1">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-ecos-gold text-sm"></i>
                  </div>
                ))}
              </div>
              <p className="text-ecos-text text-xs">200+ Reviews</p>
            </div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">

          {/* Featured */}
          <div className="lg:col-span-5 bg-ecos-charcoal rounded-sm p-10 flex flex-col justify-between">
            <div>
              <div className="flex gap-0.5 mb-6">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-ecos-gold text-base"></i>
                  </div>
                ))}
              </div>
              <div className="w-8 h-8 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-ecos-green text-3xl"></i>
              </div>
              <blockquote className="font-serif text-white text-xl lg:text-2xl leading-relaxed font-medium">
                {testimonials[0].quote}
              </blockquote>
            </div>
            <div className="flex items-center gap-4 mt-8 pt-6 border-t border-white/12">
              <div className="w-12 h-12 flex items-center justify-center bg-ecos-green rounded-full flex-shrink-0">
                <span className="text-white font-serif font-semibold text-base">{testimonials[0].name.charAt(0)}</span>
              </div>
              <div>
                <p className="text-white font-semibold text-sm">{testimonials[0].name}</p>
                <p className="text-white/45 text-xs mt-0.5">{testimonials[0].title}</p>
                <p className="text-ecos-green text-xs mt-0.5">{testimonials[0].company}</p>
              </div>
            </div>
          </div>

          {/* Grid of 3 */}
          <div className="lg:col-span-7 grid grid-cols-1 gap-5">
            {testimonials.slice(1).map((t) => (
              <div key={t.name} className="bg-white border border-ecos-border rounded-sm p-7">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex gap-0.5">
                    {[...Array(t.stars)].map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-ecos-gold text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-double-quotes-l text-ecos-green text-lg"></i>
                  </div>
                </div>
                <blockquote className="font-serif text-ecos-charcoal text-base leading-relaxed mb-5">
                  {t.quote}
                </blockquote>
                <div className="flex items-center gap-3 pt-4 border-t border-ecos-border">
                  <div className="w-9 h-9 flex items-center justify-center bg-ecos-green rounded-full flex-shrink-0">
                    <span className="text-white font-serif font-semibold text-sm">{t.name.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="text-ecos-charcoal font-semibold text-sm">{t.name}</p>
                    <p className="text-ecos-text text-xs mt-0.5">{t.title} · {t.company}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
